import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const CTA_LINK = 'https://equilibradamente.base44.app/';

const PHOTO_URL =
  'https://static.readdy.ai/image/358c420565fea72b91269b0160885e8f/e3f1b837d72c2478d21ce316c315817d.jpeg';

export default function FounderBio() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section
      className="py-28 px-6 relative overflow-hidden"
      style={{ background: '#07111F' }}
    >
      {/* Subtle radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at 50% 30%, rgba(245,165,32,0.05) 0%, transparent 65%)',
        }}
      />

      <div
        ref={ref}
        className="relative z-10 max-w-2xl mx-auto flex flex-col items-center text-center"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.8s ease, transform 0.8s ease',
        }}
      >
        {/* ── 1. Professional photo ── */}
        <div
          className="mb-10 rounded-full overflow-hidden flex-shrink-0"
          style={{
            width: 160,
            height: 160,
            border: '3px solid rgba(245,165,32,0.35)',
            boxShadow: '0 0 0 8px rgba(245,165,32,0.06)',
          }}
        >
          <img
            src={PHOTO_URL}
            alt="Reginaldo Silva — Psicoterapeuta Clínico"
            className="w-full h-full object-cover object-top"
            style={{ objectPosition: 'center top' }}
          />
        </div>

        {/* ── 2. Section title ── */}
        <span
          className="inline-block text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-5 border"
          style={{
            background: 'rgba(245,165,32,0.08)',
            color: '#F5A520',
            borderColor: 'rgba(245,165,32,0.2)',
          }}
        >
          Quem conduz essa experiência
        </span>

        {/* ── 3. Short subtitle ── */}
        <p
          className="text-base leading-relaxed mb-8 max-w-md"
          style={{ color: '#5A7A95' }}
        >
          Cuidado profissional, humano e seguro para quem precisa desacelerar com orientação.
        </p>

        {/* ── Divider ── */}
        <div
          className="w-12 mb-7 rounded-full"
          style={{ height: 2, background: 'rgba(245,165,32,0.25)' }}
        />

        {/* ── 4. Name ── */}
        <h2
          className="text-2xl md:text-3xl font-semibold text-white mb-1"
          style={{ letterSpacing: '-0.02em' }}
        >
          Reginaldo Silva
        </h2>

        {/* ── 5. Professional credential ── */}
        <p
          className="text-sm font-medium tracking-wide uppercase mb-10"
          style={{ color: '#F5A520', letterSpacing: '0.08em' }}
        >
          Psicoterapeuta Clínico
        </p>

        {/* ── 6. Main body text ── */}
        <div
          className="text-left space-y-5 mb-8 w-full"
          style={{
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: 16,
            padding: '28px 32px',
          }}
        >
          <p className="text-sm leading-relaxed" style={{ color: '#8AAFC8' }}>
            Criei esta experiência para oferecer um primeiro passo seguro a pessoas que vivem em
            estado de alerta, sobrecarga emocional, ansiedade ou mente acelerada.
          </p>
          <p className="text-sm leading-relaxed" style={{ color: '#8AAFC8' }}>
            Meu propósito é ajudar você a compreender com mais clareza o que acontece no seu
            sistema emocional e iniciar um processo de regulação com acolhimento,
            responsabilidade e condução profissional.
          </p>
          <p className="text-sm leading-relaxed" style={{ color: '#8AAFC8' }}>
            Aqui, você não encontra pressão, pressa ou fórmulas vazias.
            <br />
            Encontra um espaço seguro para começar.
          </p>
        </div>

        {/* ── 7. Specialization line ── */}
        <p
          className="text-xs font-medium tracking-wide mb-8"
          style={{ color: '#4A6A85' }}
        >
          Especialista em Hipnose Clínica, Psicanálise e princípios de Neurociência.
        </p>

        {/* ── 8. Closing emotional sentence ── */}
        <p
          className="text-base md:text-lg font-medium leading-relaxed mb-10 max-w-sm"
          style={{ color: '#B8D4E8', fontStyle: 'italic' }}
        >
          &ldquo;Você não precisa enfrentar tudo sozinho.
          <br />
          Existe um caminho seguro para começar.&rdquo;
        </p>

        {/* ── 9. Button ── */}
        <a
          href={CTA_LINK}
          target="_blank"
          rel="noreferrer"
          className="inline-block whitespace-nowrap font-semibold rounded-full px-10 py-4 text-sm cursor-pointer"
          style={{
            background: 'linear-gradient(135deg, #00C8E8, #00A3C0)',
            color: '#060D18',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-3px)';
            (e.currentTarget as HTMLAnchorElement).style.boxShadow =
              '0 10px 40px rgba(0,200,232,0.35)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
            (e.currentTarget as HTMLAnchorElement).style.boxShadow = 'none';
          }}
        >
          Iniciar sessão gratuita
        </a>
      </div>
    </section>
  );
}
